import { toastr } from 'react-redux-toastr';
import branditRails from '../../../../api/brandit_rails';
import { setFeatureFlagsAction, setFeatureFlagAction, setFeatureFlagsStatusAction, setFeatureFlagCurrentStatusAction, setFeatureFlagsErrorsAction, clearFeatureFlagsErrorsAction } from './featureFlags.actions';
export const fetchFeatureFlags = () => async (dispatch) => {
    try {
        dispatch(setFeatureFlagsStatusAction('loading'));
        dispatch(clearFeatureFlagsErrorsAction());
        const { data: featureFlags } = await branditRails.get('/admin/organization/feature_flags');
        const flagsById = featureFlags.reduce((acc, flag) => {
            acc[flag.id] = flag;
            return acc;
        }, {});
        dispatch(setFeatureFlagsAction(flagsById));
        dispatch(setFeatureFlagsStatusAction('succeeded'));
        return featureFlags;
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        dispatch(setFeatureFlagsErrorsAction({ message: errorMessage }));
        dispatch(setFeatureFlagsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const fetchFeatureFlag = (id) => async (dispatch) => {
    try {
        dispatch(setFeatureFlagCurrentStatusAction('loading'));
        dispatch(clearFeatureFlagsErrorsAction());
        const { data: featureFlagShow } = await branditRails.get(`/admin/organization/feature_flags/${id}`);
        dispatch(setFeatureFlagAction(featureFlagShow));
        dispatch(setFeatureFlagCurrentStatusAction('succeeded'));
        return featureFlagShow;
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        dispatch(setFeatureFlagsErrorsAction({ message: errorMessage }));
        dispatch(setFeatureFlagCurrentStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const createFeatureFlagAssignment = ({ featureFlagId, assignableType, assignableId, enabled }) => async (dispatch) => {
    try {
        const { data: assignment } = await branditRails.post(`/admin/organization/feature_flags/${featureFlagId}/feature_flag_assignments`, {
            feature_flag_assignment: {
                assignable_type: assignableType,
                assignable_id: assignableId,
                enabled
            }
        });
        dispatch(fetchFeatureFlag(featureFlagId));
        toastr.success('Success', 'Assignment created');
        return assignment;
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const updateFeatureFlagAssignment = ({ featureFlagId, assignmentId, enabled }) => async (dispatch) => {
    try {
        const { data: assignment } = await branditRails.patch(`/admin/organization/feature_flags/${featureFlagId}/feature_flag_assignments/${assignmentId}`, { feature_flag_assignment: { enabled } });
        dispatch(fetchFeatureFlag(featureFlagId));
        toastr.success('Success', `Assignment ${enabled ? 'enabled' : 'disabled'}`);
        return assignment;
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const deleteFeatureFlagAssignment = ({ featureFlagId, assignmentId }) => async (dispatch) => {
    try {
        await branditRails.delete(`/admin/organization/feature_flags/${featureFlagId}/feature_flag_assignments/${assignmentId}`);
        dispatch(fetchFeatureFlag(featureFlagId));
        toastr.success('Success', 'Assignment deleted');
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const checkFeatureFlag = (flagKey) => async () => {
    try {
        const { data } = await branditRails.get(`/feature_flags/${flagKey}`);
        return data.enabled;
    }
    catch {
        return false;
    }
};
